import { gql } from "@apollo/client";
import { Widget } from "./wigdetCalls";

export const AUTO_REPORT_CALLS = gql`
  query Info($domain: String!, $input: BasicQueryInfoInput!) {
    autoReport {
      info(domain: $domain, input: $input) {
        auto_report_id
        name
        filter {
          key
          value {
            id
            label
          }
        }
      }
    }
  }
`
// export const UPDATE_AUTO_REPORT = gql`
//   mutation Update($domain: String!, $input: [AutoReportInput!]!) {
//     autoReport {
//       update(domain: $domain, input: $input) {
//         code
//         success
//         message
//         updatedValues {
//           auto_report_id
//           name
//           filter {
//             key
//             value {
//               id
//               label
//             }
//           }
//         }
//       }
//     }
//   }
// `

export const CREATE_AUTO_REPORT = gql`
  mutation Create($domain: String!, $input: [AutoReportInput!]!) {
    autoReport {
      create(domain: $domain, input: $input) {
        code
        success
        message
        updatedValues {
          auto_report_id
          name
          filter {
            key
            value {
              id
              label
            }
          }
        }
      }
    }
  }
`

export const CREATE_AUTO_REPORT_AND_LINK = gql`
  mutation CreateAndLinkWithWidget($domain: String!, $input: [AutoReportInput!]!, $widgetId: Int!) {
    autoReport {
      createAndLinkWithWidget(domain: $domain, input: $input, widgetId: $widgetId) {
        code
        success
        message
        updatedValues {
          updatedWidget {
            widget_id
            name
            placement
            display_order
            type
            page
            data
            auto_reports
          }
          newAutoReports {
            auto_report_id
            name
            filter {
              key
              value {
                id
                label
              }
            }
          }
        }
      }
    }
  }
`

export const DELETE_AUTO_REPORT = gql`
  mutation Delete($domain: String!, $ids: [Int!]!) {
    autoReport {
      delete(domain: $domain, ids: $ids) {
        code
        success
        message
      }
    }
  }
`

export interface AutoReport {
  auto_report_id: number;
  name: string;
  filter: {
    key: string;
    value: {
      id: number;
      label: string;
    }[]
  }[]
}

export interface AutoReportResponse {
  autoReport: {
    info: AutoReport[];
  }
}

export interface DeleteAutoReportResponse {
  autoReport: {
    delete: {
      code: string;
      success: boolean;
      message: string;
    }
  }
}

// export interface UpdateAutoReportResponse {
//   autoReport: {
//     update: {
//       code: string;
//       success: boolean;
//       message: string;
//       updatedValues: AutoReport
//     }
//   }
// }

export interface CreateAutoReportResponse {
  autoReport: {
    create: {
      code: string;
      success: boolean;
      message: string;
      updatedValues: AutoReport[]
    }
  }
}

export interface CreateAutoReportAndLinkResponse {
  autoReport: {
    createAndLinkWithWidget: {
      code: string;
      success: boolean;
      message: string;
      updatedValues: {newAutoReports: AutoReport[], updatedWidget: Widget[]}
    }
  }
}